/**
 * Fetcher Finance
 * @author Tevin
 */

import { Fetcher } from '@components/bases/Fetcher';
import MenuPathTree from '@fetchers/datas/MenuPathTree';

export class FFinance extends Fetcher {
    constructor() {
        super({
            urlPrefix: ['/api/finance/', '/Home/Account/'],
            mockPath: MenuPathTree.projectName,
        });
    }

    // 获取订单待对账列表（订单对账）
    getOrderStatements(search, pagination, sorter) {
        const url = this.spellURL(
            'getOrderStatements',
            '../../lpg/admin/FinancialManagement/checkOrderList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 保存订单对账（订单对账）
    saveOrderStatement(statement) {
        const url = this.spellURL(
            'saveOrderStatement',
            '../../lpg/admin/FinancialManagement/checkRecord',
        );
        const send = {
            ...this.transKeyName('underline', statement),
        };
        return this.post(url, send);
    }

    // 获取押金对账列表（押金对账）
    getDepositStatements(search, pagination, sorter) {
        const url = this.spellURL(
            'getDepositStatements',
            '../../lpg/admin/FinancialManagement/checkDepositList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
            ac_date: search.acDate?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 保存押金对账（押金对账）
    saveDepositStatement(statement) {
        const url = this.spellURL(
            'saveDepositStatement',
            '../../lpg/admin/FinancialManagement/depositCheck',
        );
        const send = {
            ...this.transKeyName('underline', statement),
        };
        return this.post(url, send);
    }

    // 获取其他押金对账列表（其他押金对账）
    getOtherDepositStatements(search, pagination, sorter) {
        const url = this.spellURL(
            'getDepositStatements',
            '../../lpg/admin/FinancialManagement/CheckOtherDepositList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
            date: search.date?.replace(',', ' - '),
            ac_date: search.acDate?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取对账单列表（对账单列表）
    getStatementsChecked(search, pagination, sorter) {
        const url = this.spellURL(
            'getStatementsChecked',
            '../../lpg/admin/FinancialManagement/accountOrderList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter.field,
            sortOrder: sorter.order,
        };
        return this.post(url, send);
    }

    // 获取对账单-导出地址（对账单列表）
    getStatementsCheckedExportUrl(search) {
        const url = this.spellURL(
            '../common/defaultExportUrl',
            '../../lpg/admin/FinancialManagement/exportCheckOrder',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 保存对账单撤销（对账单列表）
    saveCancelStatementCheck(cancel) {
        const url = this.spellURL(
            'saveCancelStatementCheck',
            '../../lpg/admin/FinancialManagement/undoAccountOrder',
        );
        const send = {
            ...cancel,
        };
        return this.post(url, send);
    }

    // 获取对账单详情（对账单列表）
    getStatementDetail(statement) {
        const url = this.spellURL(
            'getStatementDetail',
            '../../lpg/admin/FinancialManagement/accountOrderDetail',
        );
        const send = {
            ...statement,
        };
        return this.post(url, send);
    }

    // 获取欠款回款列表（欠款回款状态）
    getArrearsCollection(search) {
        const url = this.spellURL(
            'getArrearsCollection',
            '../../lpg/admin/FinancialManagement/arrearsList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            datetime: search.datetime.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    getInventoryPurchases() {
        // TODO
        return Promise.resolve(null);
    }

    getInventorySaleness() {
        // TODO
        return Promise.resolve(null);
    }

    // 获取气瓶费用对账列表（气瓶费用对账）
    getBottleReconciliationList(search, pagination, sorter) {
        const url = this.spellURL(
            'getBottleReconciliationList',
            '../../lpg/admin/FinancialManagement/useFeeCheckList',
        );
        const send = {
            ...this.transKeyName('underline', search),
            page: pagination.current,
            limit: pagination.pageSize,
            sortBy: sorter?.field,
            sortOrder: sorter?.order,
        };
        return this.post(url, send);
    }

    // 保存气瓶费用对账（气瓶费用对账）
    saveBottleReconciliation(data) {
        const url = this.spellURL(
            'saveBottleReconciliation',
            '../../lpg/admin/FinancialManagement/checkUseFee',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取气瓶使用费详情
    getBottleUsageFee(data) {
        const url = this.spellURL(
            'getBottleUsageFee',
            '../../lpg/admin/FinancialManagement/useFeeCheckDetail',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }

    // 获取押金汇总（押金汇总）
    getDepositSummary(search) {
        const url = this.spellURL(
            'getDepositSummary',
            '../../lpg/admin/FinancialManagement/getDepositStatistics',
        );
        const send = {
            ...this.transKeyName('underline', search),
        };
        return this.post(url, send);
    }

    // 获取退残汇总列表（退残汇总报表）
    getResidualSummaryList(search) {
        const url = this.spellURL(
            'getResidualSummaryList',
            '../../lpg/admin/Order/residualSummaryList',
        );
        const send = {
            datetime: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 保存退残汇总导出（退残汇总报表）
    saveExportResidualSummary(search) {
        const url = this.spellURL(
            'saveExportResidualSummary',
            '../../lpg/admin/Order/export_residualSummary',
        );
        const send = {
            datetime: search.date?.replace(',', ' - '),
        };
        return this.post(url, send);
    }

    // 获取退残汇总导出结果（退残汇总报表）
    getExportResidualSummaryResult(data) {
        const url = this.spellURL(
            'getExportResidualSummaryResult',
            '../../lpg/admin/getExportResult',
        );
        const send = {
            ...this.transKeyName('underline', data),
        };
        return this.post(url, send);
    }
}

export const $fetchFinance = new FFinance();
